import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody } from '@/api/types';

import {
  getCustomerApiUrl,
  Customer,
  PaginatedCustomerListQueryFilters,
  CreateTxUser,
  CustomerMT,
  UpdateTxUser,
} from '@/api/apis/customer';
import { components } from '@/api/apis/customer/schema';

const getCustomerList = async (params: PaginatedCustomerListQueryFilters) => {
  const res = await http.get<PaginatedApiResponseBody<CustomerMT>>(getCustomerApiUrl.customersList(), { params });
  return res.data.data;
};

const createCustomer = async (body: CreateTxUser) => {
  const res = await http.post<ApiResponseBody<components['schemas']['OperationSagaStateModel']>>(
    getCustomerApiUrl.customersList(),
    body,
  );
  return res.data.data;
};

const createOrAssignCustomer = async (body: CreateTxUser) => {
  const res = await http.post<ApiResponseBody<components['schemas']['OperationSagaStateModel']>>(
    getCustomerApiUrl.customersInvite(),
    body,
  );
  return res.data.data;
};

const getCustomerById = async (customerId: string) => {
  const res = await http.get<ApiResponseBody<CustomerMT>>(getCustomerApiUrl.customerById(customerId));
  return res.data.data;
};

const updateCustomerById = async (customerId: string, body: Partial<UpdateTxUser>) => {
  const res = await http.patch<ApiResponseBody<CustomerMT>>(getCustomerApiUrl.customerById(customerId), body);
  return res.data.data;
};

const updateMyCustomer = async (body: Partial<CustomerMT>) => {
  const res = await http.patch<ApiResponseBody<Customer>>(getCustomerApiUrl.customersList(), body);
  return res.data.data;
};

const getCustomerByUserId = async (userId: string) => {
  const res = await http.get<ApiResponseBody<CustomerMT>>(getCustomerApiUrl.customerByUserId(userId));
  return res.data.data;
};

export const customerApiFetcher = {
  getCustomerById,
  createCustomer,
  createOrAssignCustomer,
  getCustomerList,
  updateCustomerById,
  getCustomerByUserId,
  updateMyCustomer,
};
